module.exports = __webpack_public_path__ + "static/media/glasbit.b74952e5.mp3";